var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.tooltip
    ? _c(
        "a",
        {
          ref: "popoverRef",
          staticClass: "tooltip-anchor",
          attrs: {
            tabindex: "0",
            role: "button",
            title: _vm.title,
            "data-bs-content": _vm.tooltip,
            "data-bs-container": "body",
            "data-bs-html": "true",
            "data-bs-placement": "right",
            "data-bs-toggle": "popover",
            "data-bs-trigger": _vm.trigger || "click",
          },
        },
        [_c("i", { staticClass: "bi-info-circle-fill" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }